import { render, staticRenderFns } from "./Compose.vue?vue&type=template&id=64c9808f&scoped=true&"
import script from "./Compose.vue?vue&type=script&lang=js&"
export * from "./Compose.vue?vue&type=script&lang=js&"
import style0 from "./Compose.vue?vue&type=style&index=0&id=64c9808f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c9808f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
